import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, throwError } from 'rxjs';
import { ApiBuilder } from '../api-builder/api/api-builder';
import { AppConfigService } from '../api-builder/config/app-config.service';
import {
  HttpRequestMethods,
  IDP_APPS
} from '../api-builder/models/api.constants';
import { HttpHeadersPayload } from '../api-builder/models/common.interfaces';
import { handleError, logCustomError } from '../error/error.utils';
import { CustomErrorBase } from '../error/models/custom-error.models';
import {
  EndpointKey,
  HTTP_HEADERS,
  IDP_APP,
  Libraries
} from './constants/deep-link-constants';
import { DecryptedData, EncryptedToken } from './interfaces/deeplink-interface';

@Injectable({
  providedIn: 'root'
})
export class DeepLinkWrapperService {
  timeout = 10000;

  retries = 3;

  decryptHeader: HttpHeadersPayload = {
    'Content-Type': 'application/json; charset=UTF-8'
  };

  _errorHandler = handleError.bind(this);

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.getConfig().subscribe((value: string[]) => {
      this.timeout = Number(value[0]);
      this.retries = Number(value[1]);
    });
  }

  getConfig(): Observable<[string, string]> {
    return forkJoin([
      this.appConfig.getConfigValue(
        IDP_APP.COMMON,
        EndpointKey.DEEP_LINK_TIMEOUT
      ),
      this.appConfig.getConfigValue(
        IDP_APP.COMMON,
        EndpointKey.DEEP_LINK_RETRY_COUNT
      )
    ]);
  }

  decryptToken = (token: string): Observable<DecryptedData> => {
    if (!token) {
      const error: CustomErrorBase = {
        code: 'ERROR_MSG_INVALID_TOKEN',
        message: 'valid token is required',
        developerMessage: ''
      };

      logCustomError(
        error,
        IDP_APPS.COMMON,
        Libraries.DEEP_LINK,
        EndpointKey.DECRYPT_TOKEN_URL
      );
      return throwError(error);
    }

    const decryptHeader: HttpHeadersPayload = {
      ...this.decryptHeader,
      Authorization: HTTP_HEADERS.GUEST
    };

    const encryptedToken: EncryptedToken = {
      token: token
    };

    return new ApiBuilder<EncryptedToken, DecryptedData>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.DECRYPT_TOKEN_URL)
      .method(HttpRequestMethods.POST)
      .payload(encryptedToken)
      .httpHeaders(decryptHeader)
      .errorHandler(this._errorHandler)
      .library('DEEP_LINK_WRAPPER_SERVICE')
      .timeOut(this.timeout)
      .retries(this.retries)
      .create();
  };
}
